import { FC } from 'react'
import { Image } from '@chakra-ui/react'

export interface FluidImageProps {
  src: string
  alt: string
}

export const FluidImage: FC<FluidImageProps> = (props) => (
  <Image {...props} fit="contain" maxHeight="100%" maxWidth="100%" />
)
